import { apiWrapper, apiCancel } from '../../wrapper';

export const initial = 'dashboard';

const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = 'json';

export const Dashboard = 'Kepegawaian/dashboard/index/';

//FILTER
export const masterWorkUnit = 'Master/List/workUnit/';

//DATA PEGAWAI
export const Ages = 'Kepegawaian/dashboard/ages/';
export const Employees = 'Kepegawaian/dashboard/employees/';
export const EmployeeStatus = 'Kepegawaian/dashboard/employeeStatus/';
export const Jabatan = 'Kepegawaian/dashboard/position/';
export const PositionGrade = 'Kepegawaian/dashboard/positionGrade/';
export const PensiunList = 'Kepegawaian/dashboard/approachRetirement/';
export const Rank = 'Kepegawaian/dashboard/rank/';
export const PensiunDoneList = 'Kepegawaian/dashboard/retirement/';
export const EmployeeType = 'Kepegawaian/dashboard/employeeType/';
export const Gender = 'Kepegawaian/dashboard/gender/';
export const Religion = 'Kepegawaian/dashboard/religion/';
export const Marital = 'Kepegawaian/dashboard/marital/';
export const Blood = 'Kepegawaian/dashboard/blood/';
export const yearService = 'Kepegawaian/dashboard/yearService/';
export const Education = 'Kepegawaian/dashboard/education/';
export const studyAssignment = 'Kepegawaian/dashboard/studyAssignment/';
export const graduationClump = 'Kepegawaian/dashboard/graduationClump/';
export const Award = 'Kepegawaian/dashboard/award/';

//DATA PRESENSI PEGAWAI
export const presensiChart = 'Kepegawaian/dashboard/presensiChart/';
export const presensiSummary = 'Kepegawaian/dashboard/presensiSummary/';
export const presensiLate = 'Kepegawaian/dashboard/presensiLate/';
export const presensiCuti = 'Kepegawaian/dashboard/presensiCuti/';

//DATA PUNISHMENT PEGAWAI
export const punishmentChart = 'Kepegawaian/dashboard/punishmentChart/';
export const punishmentList = 'Kepegawaian/dashboard/punishmentList/';

//TIDAK DIPAKE
// export const Echelon = 'Kepegawaian/dashboard/echelon/'
// export const WorkUnit = 'Kepegawaian/dashboard/workUnit/'
// export const Employee = 'Kepegawaian/dashboard/employee/'

// export const punishmentChart = 'Kepegawaian/dashboard/hukuman_disiplin_chart/'
// export const punishmentList = 'Kepegawaian/dashboard/list_hukuman_disiplin/'
// export const employeeStatistik = 'Kepegawaian/dashboard/employeeStatistik/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + 'accessExpired');
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        'post',
        'auth/getAccessToken/',
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + 'accessToken',
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject('Tidak dapat mengambil accessToken');
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
